import { useContext, useState } from 'react';
import { DocumentSettingsContext } from '../../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { PageSetupView } from '../../DocumentSettings/DocumentDesignSettings/PageSetupView';
import MarginSettings from '../../DocumentSettings/DocumentDesignSettings/margin/MarginSettings';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { FeatureFlags } from 'utils/featureFlags';
import PageOrientationSelect from '../../DocumentSettings/PageOrientationSelect';
import PageSizeSelect from '../../DocumentSettings/PageSizeSelect';
import { DEFAULT_PAGE_SIZE, type PageSize } from '../../../shared/gridConfig';

export function PageSetupSettings() {
  const { documentSettings, updateBackgroundColor, updatePageOrientation, commitBackgroundColor, captureDocumentSettings } =
    useContext(DocumentSettingsContext);
  const evaluateFeatureFlag = useFeatureFlag([FeatureFlags.pageOrientationSettings, FeatureFlags.editorPageSize]);
  const isPageOrientationEnabled = evaluateFeatureFlag[FeatureFlags.pageOrientationSettings];
  const isPageSizeEnabled = evaluateFeatureFlag[FeatureFlags.editorPageSize];
  const [pageSize, setPageSize] = useState<PageSize>(DEFAULT_PAGE_SIZE);

  return (
    <PageSetupView
      backgroundColor={documentSettings.backgroundColor}
      onColorChange={updateBackgroundColor}
      onOpen={captureDocumentSettings}
      onClose={(color) => commitBackgroundColor && commitBackgroundColor(color)}
      sizeSlot={isPageSizeEnabled ? <PageSizeSelect value={pageSize} onChange={setPageSize} /> : undefined}
      orientationSlot={
        isPageOrientationEnabled ? (
          <PageOrientationSelect value={documentSettings.pageOrientation ?? 'portrait'} onChange={updatePageOrientation} />
        ) : undefined
      }
      marginsSlot={<MarginSettings />}
    />
  );
}
